import { html } from 'lit-html';
import { LitElement, css } from 'lit-element';
import { set_effect_stack } from "../interface_functions.js";

class InsightSwitchBlockOnOff extends LitElement {
    static properties = {
        effect_id: { type: String },
    };

    static styles = css`
        div.insight_container_switch {
            display: flex;
            align-items: center;
            padding-left: 5px;
            flex-direction: row;
            position: relative;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
        }

        .toggle {
            position : relative ;
            display : inline-block;
            width : 45px;
            height : 24px;
            background-color: rgb(0,0,0,0);
            border-radius: 30px;
            border: 1px solid var(--interface-secondary-color);
            margin: 0px 5px 0px 5px;
        }

        .toggle::after {
            content: '';
            position: absolute;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: var(--interface-secondary-color);
            transition: 0.5s;
        }

        .checkbox:checked + .toggle::after {
            transform: translateX(21px);
        }

        .checkbox:checked + .toggle {
            background-color: green;
        }

        .checkbox {
            display : none;
            transition:  all 0.5s linear;
        }
    `;

    constructor(effect_id) {
        super();
        this.effect_id = effect_id; // Значение по умолчанию
    }

    onClick(event)
    {
        set_effect_stack(this.effect_id, (event.target.checked) ? 1 : 0 );
    }

    render() {
        return html`
            <div class="insight_container_switch">
                <input type="checkbox" id="switch_${this.effect_id}" class="checkbox" @click=${this.onClick}/>
                <label for="switch_${this.effect_id}" class="toggle"></label>
            </div>
        `;
    }
}

customElements.define('insight-switch-block-on-off', InsightSwitchBlockOnOff);

export function CreateInsightSwitchBlockOnOff(effect_id)
{
    let InsightSwitchBlock = new InsightSwitchBlockOnOff(effect_id);

    return InsightSwitchBlock;
}
